import { db } from "../Firebase";
import { getUserData, updateUserPackageRequest, updateUserData } from "./UserData";

const collectionName = "UserPackageData";
const dataRef = db.collection(collectionName);

export const getPackageRequest = async (reqId) => {
    const requestData = (await dataRef.doc(reqId).get()).data();
    return requestData;
}

export const getAllPackageRequests = async () => {
    const snapshot = await dataRef.where("Checked", "==", false).get();

    const packageRequests = await Promise.all(
        snapshot.docs.map(async (req) => {
            const reqData = req.data();
            const userData = await getUserData(reqData.UserId);
            const nameUser = userData.Name
                ? userData.Name
                : "";
            const lastNameUser = userData.LastName
                ? userData.LastName
                : "";
            return {
                ...reqData,
                id: req.id,
                request: reqData.Package,
                userName: `${nameUser} ${lastNameUser}`,
                userMail: userData.Mail,
                userPhone: userData.Phone,
                userPackage: userData.Package,
                userRequestId: userData.PackageRequest,
                requestType: 'package'
            };
        })
    );

    return packageRequests;
};

export const createNewPackageRequest = async (userId, pckgType, comments) => {
    let response = [];
    await dataRef.add({
        UserId: userId,
        Package: pckgType,
        Comments: comments,
        DateRequested: Date.now(),
        Checked: false,
        Approved: false
    })
        .then(async (docRef) => {
            await updateUserPackageRequest(userId, docRef.id);
        })
        .then(() => {
            response = ['success', 'Se solicitó tu paquete correctamente, en un momento será redirigido']
        })
        .catch((error) => {
            console.log(error.message);
            response = ['error', error.message]
        });
    return response;
};

export const approvePackageRequest = async (reqId, userId, pckgType) => {
    await dataRef.doc(reqId).update({
        DateChecked: Date.now(),
        Checked: true,
        Approved: true
    })
        .then(async (docRef) => {
            await updateUserData(userId, {package: docRef.id});
        })
        .catch((error) => {
            console.log(error.message);
        });
};

export const declinePackageRequest = async (reqId) => {
    await dataRef.doc(reqId).update({
        DateChecked: Date.now(),
        Checked: true,
        Approved: false
    })
        .catch((error) => {
            console.log(error.message);
        });
};

export const deletePackageRequest = async (reqId) => {
    await dataRef.doc(reqId).delete()
        .catch((error) => {
            console.log(error.message);
        });
};